exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader-wrapper{margin:250px auto;color:#fff;text-align:center;font-size:24px}.cluster img{height:100%;width:100%}.cluster-over{filter:brightness(95%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1a593bd2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/hotel-map.vue
// module id = 16
// module chunks = 0